import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getBadgesBroker,
  getBadgesBrokerClear,
} from "../../redux/certified/actions";
import { SessionKeys } from "../../utils/AppUtils";
import $ from "jquery";
import html2canvas from "html2canvas";
import {
  certificateData,
  certificateDataResponse,
  certificateDataClear,
} from "../../redux/certificateURL/actions";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import _, { filter } from "lodash";
import { Spinner } from "react-bootstrap";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";

const MyBadges = ({ setIsLoading }) => {
  const dispatch = useDispatch();

  const badgeRes = useSelector((state) => state.certified.getBadges);
  const [badgeArr, setBadgeArr] = useState([]);
  const certificateURLData = useSelector((state) => state.certificateURL);
  const [imgLoader, setImgLoader] = useState(true);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const user_id = params.get("user_id");
  const isOther =
    localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1";
  const [searchText, setSearchText] = useState("");

  var currIndex = 0;
  useEffect(() => {
    // console.log("Return me", certificateURLData);
    setImgLoader(true);
    if (
      !_.isEmpty(certificateURLData) &&
      certificateURLData?.status === "success"
    ) {
      //getBlob();
    }
    // setTimeout(() => {
    //   setImgLoader(false);
    // }, 2000);
  }, [certificateURLData]);

  useEffect(() => {
    getBadgeList();
    return () => {
      dispatch(getBadgesBrokerClear());
    };
  }, []);

  const getBadgeList = () => {
    // setIsLoading(true);
    dispatch(
      getBadgesBroker({
        module: "getBadgesBroker",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id:
            isOther === "1"
              ? user_id
              : localStorage.getItem(SessionKeys.USER_ID),
        },
      })
    );
  };

  useEffect(() => {
    if (badgeArr.length > 0) {
      for (let x = 0; x <= badgeArr.length - 1; x++) {
        let item = badgeArr[x];
        // console.log("Item Badge", item);
        if (item.badge_url === null || item.badge_url === undefined) {
          // getBlob(x, "badge", item.course_code);
        }
      }
    }
  }, [badgeArr]);

  const [filterBadgesArr, setFilterBadgesArr] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(badgeRes)) {
      if (badgeRes?.status === "success") {
        let badges = badgeRes?.payload?.payload;
        setBadgeArr(badges);
        setFilterBadgesArr(badges);
        let allUrlsNull = badges?.filter(
          (item) => item?.badge_url != null
        );
        if (allUrlsNull?.length === 0) {
          setBadgeArr([]);
          setFilterBadgesArr([]);
        }
        setImgLoader(false);
      } else {
        setBadgeArr([]);
        setImgLoader(false);
      }
      setIsLoading(false);
    }
    // console.log("badges: ", badgeArr);
  }, [badgeRes]);

  const getBlob = (index, type, course_code) => {
    // console.log("Get blob clicked with index", index);
    var HTML_Width = $(".badge-image").width();
    var HTML_Height = $(".badge-image").height();
    var top_left_margin = 18;
    var PDF_Width = HTML_Width + top_left_margin * 3;
    var PDF_Height = PDF_Width * 2 + top_left_margin * 3;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;
    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    // console.log("badge-image :", $(".badge-image"));
    html2canvas($(".badge-image")[index], {
      allowTaint: true,
      useCORS: true,
    }).then(function (canvas) {
      canvas.getContext("2d");
      // console.log(canvas.height + "  " + canvas.width);

      var imgData = canvas.toDataURL("image/jpeg", 3);
      var imgData1 = canvas.toDataURL("image/png", 3);

      // console.log("Blob1", imgData);
      // console.log("Blob3", imgData1);

      //var type = "certificate";
      //var learning_path_id =
      // certificateRes?.payload?.payload[0].learning_path_id;
      // getCertificateURL(imgData1, type, learning_path_id);

      // console.log("Url hit", badge_url);
      dispatch(
        certificateData({
          module: "myCertificateURL",
          postData: {
            img_blob: imgData1,
            course_id: course_code,
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            type: type,
          },
        })
      );

      // console.log("type clicked:", type);
    });
  };

  const renderLogo = () => {
    return (
      <svg
        id="Group_2495"
        data-name="Group 2495"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="136.417"
        height="88.677"
        viewBox="0 0 136.417 88.677"
      >
        <defs>
          <clipPath id="clip-path">
            <path
              id="Path_3234"
              data-name="Path 3234"
              d="M42.884,34.338a.018.018,0,0,1,.007.007l0-.007Z"
              transform="translate(-42.884 -34.338)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-2">
            <path
              id="Path_3235"
              data-name="Path 3235"
              d="M.786.182A1.383,1.383,0,0,0,.6.3C.554.334.515.37.476.4A1.5,1.5,0,0,0,1.854,2.952h0l25.967,34.6L2.155,71.682A1.5,1.5,0,0,0,.771,74.231c.037.036.08.071.121.105a1.149,1.149,0,0,0,.19.118,1.5,1.5,0,0,0,1.874-.373v0a.486.486,0,0,1,.034-.043h0a1.487,1.487,0,0,0,.3-.895,1.52,1.52,0,0,0-.2-.752l26.2-34.837L2.795,2.25A1.5,1.5,0,0,0,2.7.6L2.672.569l0,0v0C2.663.557,2.657.547,2.649.54A1.508,1.508,0,0,0,.786.182"
              transform="translate(0 -0.004)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-3">
            <path
              id="Path_3236"
              data-name="Path 3236"
              d="M26.26,20.208a1,1,0,0,0-.093.053c-.03.019-.062.04-.092.063s-.083.068-.122.1a1.5,1.5,0,0,0,1.383,2.546l18.7,24.844L47.747,50.1,27.73,76.677a1.495,1.495,0,0,0-1.382,2.544,1.3,1.3,0,0,0,.121.1.993.993,0,0,0,.185.118,1.5,1.5,0,0,0,1.876-.364.3.3,0,0,1,.025-.035s.007-.009.012-.013a1.5,1.5,0,0,0,.1-1.649l18.3-24.3L49.215,50.1l-2.243-2.985-18.7-24.844a1.51,1.51,0,0,0-.1-1.651.79.79,0,0,0-.056-.072,1.508,1.508,0,0,0-1.142-.524,1.477,1.477,0,0,0-.715.184"
              transform="translate(-25.48 -20.024)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-4">
            <path
              id="Path_3237"
              data-name="Path 3237"
              d="M42.837,28.049a1.32,1.32,0,0,0-.19.119c-.041.033-.085.069-.122.1a1.5,1.5,0,0,0-.2,1.962l.025.032.013.017,0,.007a1.511,1.511,0,0,0,1.538.529l18.181,24.2-18.181,24.2a1.5,1.5,0,0,0-1.53.52.159.159,0,0,0-.024.032s0,0-.006,0a1.5,1.5,0,0,0,.18,1.991,1.2,1.2,0,0,0,.122.1,1.059,1.059,0,0,0,.19.119,1.5,1.5,0,0,0,2.008-2.063L63.555,55.016l-18.709-24.9a1.5,1.5,0,0,0-1.3-2.246,1.476,1.476,0,0,0-.71.181"
              transform="translate(-42.05 -27.868)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-5">
            <path
              id="Path_3238"
              data-name="Path 3238"
              d="M33.089,0a1.489,1.489,0,0,0-.7.179A1.135,1.135,0,0,0,32.2.3c-.043.032-.083.068-.12.1a1.5,1.5,0,0,0-.19,1.974.9.9,0,0,0,.056.075,0,0,0,0,0,0,0,1.5,1.5,0,0,0,1.512.5L59.486,37.617,48.511,52.194l-2.37,3.147L33.849,71.683h0a1.5,1.5,0,0,0-1.522.509l-.012.015a.246.246,0,0,1-.022.028v0l-.006.007a1.5,1.5,0,0,0,.181,1.985c.037.036.079.071.122.105a1.048,1.048,0,0,0,.19.118,1.5,1.5,0,0,0,2.009-2.066L60.956,37.617,34.4,2.247A1.5,1.5,0,0,0,33.107,0Z"
              transform="translate(-31.604)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-6">
            <path
              id="Path_3239"
              data-name="Path 3239"
              d="M59.2,21.516a.481.481,0,0,0-.071.035,1.389,1.389,0,0,0-.191.119c-.042.033-.083.068-.122.1a1.5,1.5,0,0,0-.176,1.993l.019.023a1.5,1.5,0,0,0,1.537.531h0l3.462,4.572L80.205,50.941,73.03,60.522,60.571,77.069a1.5,1.5,0,0,0-1.5.482c-.006.007-.011.01-.018.018l0,0h0a.061.061,0,0,1-.008.016.045.045,0,0,0-.013.013.082.082,0,0,0-.013.018,0,0,0,0,1,0,0v0L59,77.632s0,0,0,.007h0s0,0-.005.005a1.5,1.5,0,0,0,.192,1.972c.037.035.08.069.122.1a1.1,1.1,0,0,0,.189.12c.024.013.051.025.073.034a1.495,1.495,0,0,0,1.936-2.1l11.515-15.31.007,0L84.738,78.1h17.285L81.67,50.941l20.377-27.154h-17.3L73.026,39.416,61.134,23.62a1.534,1.534,0,0,0,.2-.753,1.5,1.5,0,0,0-2.137-1.35"
              transform="translate(-58.34 -21.372)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-7">
            <rect
              id="Rectangle_2140"
              data-name="Rectangle 2140"
              width="136.417"
              height="88.677"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Group_2496"
          data-name="Group 2496"
          transform="translate(16.011 12.82)"
        >
          <g
            id="Group_2495-2"
            data-name="Group 2495"
            clip-path="url(#clip-path)"
          >
            <rect
              id="Rectangle_2134"
              data-name="Rectangle 2134"
              width="0.007"
              height="0.007"
              transform="translate(0 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_2498"
          data-name="Group 2498"
          transform="translate(0 0.001)"
        >
          <g
            id="Group_2497"
            data-name="Group 2497"
            clip-path="url(#clip-path-2)"
          >
            <rect
              id="Rectangle_2135"
              data-name="Rectangle 2135"
              width="29.457"
              height="74.791"
              transform="translate(-0.165 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_2500"
          data-name="Group 2500"
          transform="translate(9.513 7.476)"
        >
          <g
            id="Group_2499"
            data-name="Group 2499"
            clip-path="url(#clip-path-3)"
          >
            <rect
              id="Rectangle_2136"
              data-name="Rectangle 2136"
              width="23.899"
              height="59.76"
              transform="translate(-0.163 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_2502"
          data-name="Group 2502"
          transform="translate(15.7 10.405)"
        >
          <g
            id="Group_2501"
            data-name="Group 2501"
            clip-path="url(#clip-path-4)"
          >
            <rect
              id="Rectangle_2137"
              data-name="Rectangle 2137"
              width="21.666"
              height="54.47"
              transform="translate(-0.161 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_2504" data-name="Group 2504" transform="translate(11.799)">
          <g
            id="Group_2503"
            data-name="Group 2503"
            clip-path="url(#clip-path-5)"
          >
            <rect
              id="Rectangle_2138"
              data-name="Rectangle 2138"
              width="29.516"
              height="74.801"
              transform="translate(-0.164 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_2506"
          data-name="Group 2506"
          transform="translate(21.782 7.979)"
        >
          <g
            id="Group_2505"
            data-name="Group 2505"
            clip-path="url(#clip-path-6)"
          >
            <rect
              id="Rectangle_2139"
              data-name="Rectangle 2139"
              width="43.872"
              height="58.802"
              transform="translate(-0.165 0)"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_2508" data-name="Group 2508">
          <g
            id="Group_2507"
            data-name="Group 2507"
            clip-path="url(#clip-path-7)"
          >
            <path
              id="Path_3240"
              data-name="Path 3240"
              d="M182.419,66.9a5.8,5.8,0,0,0-1.245-1.051,11.134,11.134,0,0,0-1.75-.913,12.36,12.36,0,0,0-2.119-.662,11.1,11.1,0,0,0-2.392-.253,7.511,7.511,0,0,0-4.725,1.206,4.015,4.015,0,0,0-1.5,3.306,3.673,3.673,0,0,0,.428,1.866,3.515,3.515,0,0,0,1.342,1.264,10.124,10.124,0,0,0,2.275.914q1.36.39,3.227.817a33.686,33.686,0,0,1,3.871,1.07,11.312,11.312,0,0,1,2.956,1.5,6,6,0,0,1,1.865,2.177,6.989,6.989,0,0,1,.643,3.151,7.2,7.2,0,0,1-.778,3.441,6.9,6.9,0,0,1-2.12,2.412,9.164,9.164,0,0,1-3.169,1.4,16.7,16.7,0,0,1-3.967.448,18.319,18.319,0,0,1-6.048-.992,16.906,16.906,0,0,1-5.191-2.9l1.672-2.955a9.222,9.222,0,0,0,1.614,1.322,12.952,12.952,0,0,0,2.255,1.185,16.553,16.553,0,0,0,2.721.856,13.738,13.738,0,0,0,3.053.331,8.474,8.474,0,0,0,4.59-1.05,3.883,3.883,0,0,0,1.108-5.114A4.461,4.461,0,0,0,179.5,78.29a11.956,11.956,0,0,0-2.51-1.03q-1.5-.446-3.4-.914a33.93,33.93,0,0,1-3.7-1.089,10.028,10.028,0,0,1-2.664-1.4,5.3,5.3,0,0,1-1.616-1.984,6.579,6.579,0,0,1-.544-2.8,7.883,7.883,0,0,1,.739-3.5,7.364,7.364,0,0,1,2.062-2.567,8.983,8.983,0,0,1,3.15-1.575,15.32,15.32,0,0,1,9.023.33,14.154,14.154,0,0,1,4.005,2.3Z"
              transform="translate(-102.784 -38.166)"
              fill="#fff"
            />
            <path
              id="Path_3241"
              data-name="Path 3241"
              d="M252.037,85.928v3.111H233.292V61.427h18.4v3.111h-14.9v8.945h12.951V76.4H236.792v9.528Z"
              transform="translate(-146.191 -38.493)"
              fill="#fff"
            />
            <path
              id="Path_3242"
              data-name="Path 3242"
              d="M296.311,89.039V61.427h3.5v24.5h15.4v3.111Z"
              transform="translate(-185.681 -38.493)"
              fill="#fff"
            />
            <path
              id="Path_3243"
              data-name="Path 3243"
              d="M1.844,227.21v-6.056H5.819v.529H2.441v2.226H5.289v.5H2.441v2.806Z"
              transform="translate(-1.156 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3244"
              data-name="Path 3244"
              d="M28.128,227.181a2.576,2.576,0,0,1-1.157-.259,2.883,2.883,0,0,1-.9-.691,3.126,3.126,0,0,1-.581-.986,3.236,3.236,0,0,1-.2-1.134,3.148,3.148,0,0,1,.217-1.16,3.224,3.224,0,0,1,.6-.982,2.894,2.894,0,0,1,.9-.678,2.557,2.557,0,0,1,1.126-.252,2.5,2.5,0,0,1,1.156.269,2.91,2.91,0,0,1,.9.7,3.238,3.238,0,0,1,.576.985,3.18,3.18,0,0,1,.2,1.122,3.141,3.141,0,0,1-.218,1.16,3.182,3.182,0,0,1-.6.976,2.882,2.882,0,0,1-.9.675,2.559,2.559,0,0,1-1.125.251m-2.246-3.07a2.824,2.824,0,0,0,.163.951,2.572,2.572,0,0,0,.461.809,2.257,2.257,0,0,0,.707.563,1.982,1.982,0,0,0,.914.209,1.946,1.946,0,0,0,.929-.222,2.267,2.267,0,0,0,.709-.579,2.727,2.727,0,0,0,.447-.811,2.809,2.809,0,0,0,.158-.921,2.753,2.753,0,0,0-.167-.952,2.656,2.656,0,0,0-.465-.806,2.307,2.307,0,0,0-.709-.558,1.952,1.952,0,0,0-.9-.21,1.976,1.976,0,0,0-.93.218,2.21,2.21,0,0,0-.708.576,2.662,2.662,0,0,0-.448.811,2.766,2.766,0,0,0-.159.921"
              transform="translate(-15.845 -138.512)"
              fill="#fff"
            />
            <path
              id="Path_3245"
              data-name="Path 3245"
              d="M54.94,227.211v-6.056H57.5a1.569,1.569,0,0,1,.72.166,1.926,1.926,0,0,1,.569.435,2,2,0,0,1,.37.61,1.891,1.891,0,0,1,.133.69,2.047,2.047,0,0,1-.1.636,1.915,1.915,0,0,1-.273.545,1.657,1.657,0,0,1-.422.41,1.489,1.489,0,0,1-.555.226l1.484,2.337h-.674l-1.424-2.235H55.537v2.235Zm.6-2.764h1.979a1.014,1.014,0,0,0,.483-.114,1.161,1.161,0,0,0,.371-.311,1.546,1.546,0,0,0,.239-.444,1.6,1.6,0,0,0,.086-.521,1.408,1.408,0,0,0-.1-.524,1.385,1.385,0,0,0-.265-.439,1.249,1.249,0,0,0-.39-.3,1.054,1.054,0,0,0-.473-.111h-1.93Z"
              transform="translate(-34.428 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3246"
              data-name="Path 3246"
              d="M98.533,227.211v-6.056h2.559a1.58,1.58,0,0,1,.722.166,1.91,1.91,0,0,1,.566.435,1.991,1.991,0,0,1,.372.61,1.921,1.921,0,0,1,.131.69,2.035,2.035,0,0,1-.1.636,1.944,1.944,0,0,1-.272.545,1.669,1.669,0,0,1-.422.41,1.5,1.5,0,0,1-.556.226l1.484,2.337h-.673l-1.425-2.235H99.13v2.235Zm.6-2.764h1.98a1.014,1.014,0,0,0,.482-.114,1.165,1.165,0,0,0,.371-.311,1.527,1.527,0,0,0,.238-.444,1.589,1.589,0,0,0,.085-.521,1.46,1.46,0,0,0-.362-.963,1.254,1.254,0,0,0-.391-.3,1.058,1.058,0,0,0-.475-.111H99.13Z"
              transform="translate(-61.745 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3247"
              data-name="Path 3247"
              d="M128.945,226.682v.528h-4.069v-6.056h3.993v.529h-3.4v2.184h2.959v.5h-2.959v2.312Z"
              transform="translate(-78.253 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3248"
              data-name="Path 3248"
              d="M150.987,221.154h.5l2.516,6.056h-.631l-.785-1.894h-2.721l-.776,1.894h-.641Zm1.469,3.693-1.221-2.993L150,224.847Z"
              transform="translate(-93.028 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3249"
              data-name="Path 3249"
              d="M177.083,227.21v-6.056h.6v5.528h3.5v.528Z"
              transform="translate(-110.968 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3250"
              data-name="Path 3250"
              d="M222.527,226.682v.528h-4.07v-6.056h3.993v.529h-3.395v2.184h2.959v.5h-2.959v2.312Z"
              transform="translate(-136.895 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3251"
              data-name="Path 3251"
              d="M246.178,222.218a1.84,1.84,0,0,0-.682-.47,2.5,2.5,0,0,0-.974-.179,1.823,1.823,0,0,0-1.168.3,1.009,1.009,0,0,0-.367.823.893.893,0,0,0,.1.448.844.844,0,0,0,.3.3,2.081,2.081,0,0,0,.525.223c.212.062.464.124.753.187a7.952,7.952,0,0,1,.875.23,2.54,2.54,0,0,1,.661.32,1.316,1.316,0,0,1,.417.466,1.435,1.435,0,0,1,.145.682,1.527,1.527,0,0,1-.161.725,1.441,1.441,0,0,1-.451.511,2.015,2.015,0,0,1-.691.3,3.711,3.711,0,0,1-.879.1,3.619,3.619,0,0,1-2.431-.878l.3-.487a2.438,2.438,0,0,0,.388.324,2.9,2.9,0,0,0,.5.268,3.263,3.263,0,0,0,.594.179,3.366,3.366,0,0,0,.665.064,2.081,2.081,0,0,0,1.131-.261.873.873,0,0,0,.4-.788.9.9,0,0,0-.115-.473.983.983,0,0,0-.346-.333,2.427,2.427,0,0,0-.57-.243q-.342-.1-.794-.2-.478-.111-.836-.23a2.223,2.223,0,0,1-.607-.3,1.152,1.152,0,0,1-.37-.43,1.4,1.4,0,0,1-.124-.618,1.691,1.691,0,0,1,.158-.746,1.456,1.456,0,0,1,.449-.546,2.08,2.08,0,0,1,.681-.333,3.091,3.091,0,0,1,.871-.115,2.964,2.964,0,0,1,1.078.183,2.891,2.891,0,0,1,.858.516Z"
              transform="translate(-151.742 -138.513)"
              fill="#fff"
            />
            <path
              id="Path_3252"
              data-name="Path 3252"
              d="M271.9,221.683h-2.157v5.528h-.6v-5.528h-2.157v-.529H271.9Z"
              transform="translate(-167.306 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3253"
              data-name="Path 3253"
              d="M293.165,221.154h.505l2.516,6.056h-.63l-.786-1.894h-2.721l-.777,1.894h-.639Zm1.468,3.693-1.22-2.993-1.236,2.993Z"
              transform="translate(-182.122 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3254"
              data-name="Path 3254"
              d="M320.929,221.683h-2.158v5.528h-.6v-5.528h-2.158v-.529h4.914Z"
              transform="translate(-198.029 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3255"
              data-name="Path 3255"
              d="M347.093,226.682v.528h-4.07v-6.056h3.993v.529H343.62v2.184h2.961v.5H343.62v2.312Z"
              transform="translate(-214.953 -138.585)"
              fill="#fff"
            />
            <path
              id="Path_3256"
              data-name="Path 3256"
              d="M355.781,136.188a2.2,2.2,0,1,1,2.2-2.2,2.2,2.2,0,0,1-2.2,2.2m0-4.129a1.926,1.926,0,1,0,1.926,1.927,1.928,1.928,0,0,0-1.926-1.927"
              transform="translate(-221.566 -82.58)"
              fill="#fff"
            />
            <path
              id="Path_3257"
              data-name="Path 3257"
              d="M356.68,135.611a1.257,1.257,0,0,1,.075-.424,1.166,1.166,0,0,1,.217-.376,1.118,1.118,0,0,1,.354-.271,1.042,1.042,0,0,1,.473-.1.978.978,0,0,1,.54.142.859.859,0,0,1,.332.372l-.183.113a.724.724,0,0,0-.137-.2.811.811,0,0,0-.175-.13.7.7,0,0,0-.193-.071.947.947,0,0,0-.2-.022.789.789,0,0,0-.375.087.843.843,0,0,0-.274.226,1,1,0,0,0-.168.313,1.143,1.143,0,0,0-.056.353,1.036,1.036,0,0,0,.068.377,1.067,1.067,0,0,0,.185.317.928.928,0,0,0,.279.22.769.769,0,0,0,.349.081.88.88,0,0,0,.2-.025.819.819,0,0,0,.2-.08.857.857,0,0,0,.18-.136.713.713,0,0,0,.14-.2l.193.1a.717.717,0,0,1-.16.233.976.976,0,0,1-.227.171,1.229,1.229,0,0,1-.269.108,1.13,1.13,0,0,1-.277.035.931.931,0,0,1-.445-.106,1.158,1.158,0,0,1-.349-.277,1.282,1.282,0,0,1-.227-.389,1.253,1.253,0,0,1-.082-.443"
              transform="translate(-223.511 -84.243)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  };

  useEffect(() => {
    if (searchText?.length > 2) {
      console.log("cer---", filterBadgesArr);
      let data = filterBadgesArr.filter((item) =>
        _.toLower(item?.course_name).includes(_.toLower(searchText))
      );
      setBadgeArr(data);
    } else if (
      searchText === "" ||
      searchText === undefined ||
      searchText === null
    ) {
      setBadgeArr(filterBadgesArr);
    }
  }, [searchText]);

  return (
    <section id="badge" className="container-badge">
      <div className=" MyCertifate">
        <div className="row badges-sections">
          {/* <div className="col-md-12">
            <h4>Badges</h4>
            <div className="search-info">
              <div className="input-text position-relative d-flex">
                <label htmlFor="search" className="input__label">
                  Search
                </label>
                <input
                  type="search"
                  id="search"
                  name="search"
                  className="input_field mr-2"
                  placeholder="search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
          </div> */}
          <div className="profile-info-title d-flex justify-content-between gap-3 align-items-center">
            <div className="title-box">Badges</div>
            {false && (
              <div className="search-info">
                <div className="input-text position-relative d-flex">
                  <label htmlFor="search" className="input__label">
                    Search
                  </label>
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="input_field mr-2"
                    placeholder="search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>

          {imgLoader ? (
            <div className="d-flex justify-content-center w-100">
              {/* <Spinner animation="border" /> */}
              {[0, 1, 2].map((item, index) => {
                return (
                  <div key={index} className="col-md-4 mb-4">
                    <ShimmerScreen
                      case={"rect"}
                      width={"95%"}
                      height={"270px"}
                    />
                  </div>
                );
              })}
            </div>
          ) : badgeArr?.length > 0 ? (
            badgeArr.map((item, index) => {
              return (
                <div
                  className="col-xl-3 col-lg-4 col-md-4 badge-sec mt-3"
                  key={index}
                >
                  <div id={"badge-image" + index}>
                    <div className="badge-image">
                      {item?.badge_url != null ? (
                        <img src={item?.badge_url} />
                      ) : ( ""
                        // <div
                        //   className={
                        //     index % 2 === 0
                        //       ? "badges-section badges-section-bg-red"
                        //       : "badges-section badges-section-bg-orange"
                        //   }
                        // >
                        //   <div className="badge-content">
                        //     <div className="logo-badge">
                        //       {/* <img src="/images/bagde-logo.svg" alt="" /> */}
                        //       {renderLogo()}
                        //     </div>
                        //     <div className="badge-text">
                        //       <p>Masterclass</p>
                        //       <p
                        //         dangerouslySetInnerHTML={{
                        //           __html: item?.course_name,
                        //         }}
                        //       ></p>
                        //     </div>
                        //   </div>
                        // </div>
                      )}
                    </div>
                    {item.badge_url!==null && <div className="certificateshare icons d-flex justify-content-center">
                            <div className="button-reset sharebtn">
                              <button
                                id={"certificateSharePrint" + index}
                                onClick={() => {
                                  window.open(
                                    "https://www.facebook.com/sharer/sharer.php?u=" +
                                      item?.social_url,
                                    "_blank"
                                  );
                                }}
                                // url={item?.certificate_url}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  id="facebook"
                                  data-name="facebook"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 30 30"
                                >
                                  <defs>
                                    <linearGradient
                                      id="linear-gradients"
                                      y1="0.5"
                                      x2="1"
                                      y2="0.5"
                                      gradientUnits="objectBoundingBox"
                                    >
                                      <stop offset="0" stopColor="#00b7f1" />
                                      <stop offset="1" stopColor="#ed156e" />
                                    </linearGradient>
                                  </defs>
                                  <circle
                                    id="Ellipse_198"
                                    data-name="Ellipse 198"
                                    cx="15"
                                    cy="15"
                                    r="15"
                                    fill="url(#linear-gradients)"
                                  />
                                  <circle
                                    id="Ellipse_199"
                                    data-name="Ellipse 199"
                                    cx="13"
                                    cy="13"
                                    r="13"
                                    transform="translate(2 2)"
                                    fill="#fff"
                                    className="fillwhite"
                                  />
                                  <path
                                    id="Icon_awesome-facebook-f"
                                    data-name="Icon awesome-facebook-f"
                                    d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                                    transform="translate(9.487 7.713)"
                                    fill="#774d9f"
                                  />
                                </svg>
                              </button>
                            </div>

                            <div className="button-reset sharebtn">
                              <button
                                onClick={() => {
                                  window.open(
                                    "https://www.linkedin.com/sharing/share-offsite/?url=" +
                                      item?.social_url,
                                    "_blank"
                                  );
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  id="linkedin"
                                  data-name="linkedin"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 30 30"
                                >
                                  <defs>
                                    <linearGradient
                                      id="linear-gradients"
                                      y1="0.5"
                                      x2="1"
                                      y2="0.5"
                                      gradientUnits="objectBoundingBox"
                                    >
                                      <stop offset="0" stopColor="#00b7f1" />
                                      <stop offset="1" stopColor="#ed156e" />
                                    </linearGradient>
                                  </defs>
                                  <circle
                                    id="Ellipse_57"
                                    data-name="Ellipse 57"
                                    cx="15"
                                    cy="15"
                                    r="15"
                                    fill="url(#linear-gradients)"
                                  />
                                  <circle
                                    id="Ellipse_179"
                                    data-name="Ellipse 179"
                                    cx="13"
                                    cy="13"
                                    r="13"
                                    transform="translate(2 2)"
                                    fill="#fff"
                                    className="fillwhite"
                                  />
                                  <path
                                    id="Icon_awesome-linkedin-in"
                                    data-name="Icon awesome-linkedin-in"
                                    d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                                    transform="translate(8.788 8.789)"
                                    fill="#7a549e"
                                  />
                                </svg>
                              </button>
                              {/* <ShareMe /> */}
                            </div>
                     </div>}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-md-12">
              <div className="not-found mt-3">
                <div className="interboxes">
                <NotFoundImage />
                  {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                  <p>Get Badges by doing paid courses.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default MyBadges;
